export default __webpack_public_path__ + "static/media/deleteAccountDescriptionThumbnail.ec4ebfe1.svg";